import 'css-chunksrc/client/common/layout/openButton/styles.scss';export default {
  "openButton": "_openButton_qqymu_1"
};